import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export function Timepicker({ label, onChange, path, value, disable, requiredField, error }) {
  const timeSelectd = value ? new Date(value) : null;
  return (
    <>
      <div className="dt_picker py-1 position-relative">
        <label className="asterisk-req">
          {label}
          {requiredField && <span>*</span>}
        </label>
        <DatePicker
          selected={timeSelectd}
          popperPlacement="top-end"
          name="selectedDate"
          showTimeSelect
          disabled={disable}
          timeIntervals={5}
          timeCaption="Time"
          timeFormat="HH:mm"
          dateFormat="HH:mm"
          showTimeSelectOnly
          autoComplete="off"
          onChange={(date) => onChange(date, path)}
        />
        <button type="button" className="btn-calender btn move_up" aria-label="Calendar" disabled={disable}>
          <i className="icon-clock" />
        </button>
      </div>
      {error?.status && <span className="error-message">{error.errorMsg}</span>}
    </>
  );
}
export default Timepicker;
